import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { removeTab, removeTabFromOld, activeTab } from '../../actions'

function mapStateToProps(state) {
    return {
        tabs: state.getIn(['ui', 'tabs', 'tabs']),
        activeModule: state.getIn(['ui', 'moduleMenu', 'active']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ removeTab, removeTabFromOld, activeTab }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            activeModule: PropTypes.string.isRequired,
            tabs: IPropTypes.list.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (!this.props.tabs.equals(nextProps.tabs)) return true
            if (!this.props.activeModule !== nextProps.activeModule) return true

            return false
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
